import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagMedium = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.90909 2.90912C2.40701 2.90912 2 3.31613 2 3.81821V20.1818C2 20.6839 2.40701 21.0909 2.90909 21.0909C3.41117 21.0909 3.81818 20.6839 3.81818 20.1818V14.9546H21.0909C21.3994 14.9546 21.6869 14.7981 21.8544 14.539C22.0219 14.2799 22.0465 13.9536 21.9199 13.6723L19.7856 8.93185L21.9199 4.19142C22.0465 3.9101 22.0219 3.58375 21.8544 3.32467C21.6869 3.06558 21.3994 2.90912 21.0909 2.90912H2.90909Z",
		fill: "#FF8A4C"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.2116 12.6783C8.7276 12.6783 8.4856 12.4363 8.4856 11.9523V5.70433C8.4856 5.42567 8.55893 5.235 8.7056 5.13233C8.85226 5.02967 9.06493 4.97833 9.3436 4.97833C9.72493 4.97833 10.0109 5.14333 10.2016 5.47333L12.0056 8.60833L13.7876 5.48433C13.9049 5.279 14.0369 5.14333 14.1836 5.07733C14.3376 5.01133 14.5393 4.97833 14.7886 4.97833C15.2726 4.97833 15.5146 5.22033 15.5146 5.70433V11.9523C15.5146 12.4363 15.2726 12.6783 14.7886 12.6783C14.3046 12.6783 14.0626 12.4363 14.0626 11.9523V7.45333L12.6986 9.93933C12.5226 10.2767 12.2879 10.4453 11.9946 10.4453C11.7013 10.4453 11.4666 10.2767 11.2906 9.93933L9.9266 7.45333V11.9523C9.9266 12.4363 9.68826 12.6783 9.2116 12.6783Z",
		fill: "#111928"
	})]
});
export default SvgFlagMedium;
